// src/LoginPage.jsx
import { useState } from 'react';
import { useAuth } from '../utils/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await login(username, password);
      window.location.href='/dashboard';
    } catch {
      setError('Invalid username or password');
    }
  }

  return (
    <div className='min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100'>

      {/* Login card  */}
      <div className='flex items-center justify-center px-6 py-24'>
        <div className='w-full max-w-md p-10 rounded-xl shadow-2xl bg-white/90 backdrop-blur-md'>
          <h3 className='text-3xl font-bold text-docpgrPurple mb-8 text-center'>
            get invoco
          </h3>

          <form onSubmit={handleSubmit} className='space-y-6'>
            <input type='text' placeholder='username or email address' name='username' value={username} onChange={(event) => setUsername(event.target.value)} className='w-full p-3 rounded-md border border-gray-300 text-lg focus:outline-none focus:ring-2 focus:ring-docpgrPurple focus:border-docpgrPurple transition'/>
            <input type='password' placeholder='password' value={password} onChange={(event) => setPassword(event.target.value)} className='w-full p-3 rounded-md border border-gray-300 text-lg focus:outline-none focus:ring-2 focus:ring-docpgrPurple focus:border-docpgrPurple transition' />

            <button type='submit' className='w-full px-6 py-3 mt-4 rounded-lg text-white font-bold voco-gradient-hover shadow-md hover:shadow-docpgr-purple-glow transition flex items-center justify-center gap-2'>
              <span>sign in</span> <img src='/assets/invoco_icon_transparent_white.webp' alt='invoco icon' className='h-6 w-6/'/>
            </button>
          </form>

          {error && (
            <div className='mt-4 text-center text-lg font-bold text-[color:var(--imperial-red)]'>
              {error}
            </div>
          )}

          {/* forgot password  */}
          <div className='mt-4 text-right'>
            <button onClick={() => navigate('/forgot-password')} className='text-docpgrPurple font-bold text-xs hover:text-docpgrPurple70'>
              forgot password?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}